module.exports = __webpack_public_path__ + "img/cloth_g3_pants-06.51bc5c59.svg";